import { breakpoints, Card, Heading, Inline, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { duration as durationUtil } from '@eti/utils';
import { useSiteContext } from '@eti/providers';
import { CABIN_UPGRADE } from '../../../products';
import { OriginDestinationText } from '../OriginDestinationText';
import CabinUpgradeOptOutCheckbox from './CabinUpgradeOptOutCheckbox';
import CabinUpgradeAvailableOptions from './CabinUpgradeAvailableOptions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const availableSegmentHeadingStyles = css`
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${breakpoints._768}) {
    align-items: center;
    flex-direction: row;
  }
`;
const cardSelectionTextStyles = css`
  margin: 8px 0;
`;
const CabinUpgradeAvailableSegmentCard = ({
  drawerTexts,
  originDestinationAirportAriaLabelText,
  flightRoute,
  segmentKey,
  segmentUpgrade,
  selectedCabinUpgradeOptions,
  setSelectedCabinUpgradeOptions,
  unselectedCabinUpgrades,
  setUnselectedCabinUpgrades
}) => {
  const {
    language,
    timeFormat
  } = useSiteContext();
  const {
    drawerCheckboxSelectionLabel,
    drawerCardFlightDuration,
    drawerCardSelectionTitle
  } = drawerTexts;
  return /*#__PURE__*/_jsxs(Card, {
    "data-testid": `${CABIN_UPGRADE.name}-selection-card-available-${segmentKey}`,
    children: [/*#__PURE__*/_jsxs(Inline, {
      className: availableSegmentHeadingStyles,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Heading, {
        "aria-label": originDestinationAirportAriaLabelText,
        "data-testid": `${CABIN_UPGRADE.name}-origin-destination-heading-${segmentKey}`,
        level: 3,
        children: /*#__PURE__*/_jsx(OriginDestinationText, {
          flightRoute: flightRoute
        })
      }), segmentUpgrade.duration && /*#__PURE__*/_jsxs(Inline, {
        "data-testid": `${CABIN_UPGRADE.name}-flight-duration-${segmentKey}`,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(Text, {
          children: drawerCardFlightDuration
        }), /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: durationUtil.getDuration(segmentUpgrade.duration, language.code, timeFormat)
        })]
      })]
    }), /*#__PURE__*/_jsx(Text, {
      "aria-hidden": "true",
      as: "p",
      className: cardSelectionTextStyles,
      "data-testid": `${CABIN_UPGRADE.name}-heading-${segmentKey}`,
      variant: "16-bold",
      children: drawerCardSelectionTitle
    }), /*#__PURE__*/_jsx(CabinUpgradeAvailableOptions, {
      drawerTexts: drawerTexts,
      originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
      segmentKey: segmentKey,
      segmentUpgrade: segmentUpgrade,
      selectedCabinUpgradeOptions: selectedCabinUpgradeOptions,
      setSelectedCabinUpgradeOptions: setSelectedCabinUpgradeOptions,
      setUnselectedCabinUpgrades: setUnselectedCabinUpgrades
    }), /*#__PURE__*/_jsx(CabinUpgradeOptOutCheckbox, {
      checkboxSelectionLabel: drawerCheckboxSelectionLabel,
      originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
      segmentKey: segmentKey,
      setSelectedCabinUpgradeOptions: setSelectedCabinUpgradeOptions,
      setUnselectedCabinUpgrades: setUnselectedCabinUpgrades,
      unselectedCabinUpgrades: unselectedCabinUpgrades
    })]
  }, segmentKey);
};
export default CabinUpgradeAvailableSegmentCard;
//# sourceMappingURL=CabinUpgradeAvailableSegmentCard.js.map